import { useEffect, useRef, useState } from "react";
import { formatRupiah } from "@/lib/dirga";

// Smoothly counts from the previous value to the new total.
export const AnimatedRupiah = ({ value, className, testId }) => {
  const [display, setDisplay] = useState(value);
  const rafRef = useRef();
  const fromRef = useRef(value);

  useEffect(() => {
    const from = fromRef.current;
    const to = value;
    if (from === to) return;
    const duration = 450;
    const start = performance.now();

    const tick = (now) => {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(Math.round(from + (to - from) * eased));
      if (t < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        fromRef.current = to;
      }
    };

    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value]);

  return (
    <span className={className} data-testid={testId}>
      {formatRupiah(display)}
    </span>
  );
};
